// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"eaa1c192","443":"f8e534dd","453":"c8b1ee44","548":"1d3a236f","579":"b200f04b","778":"31c163e7","796":"5ce426f1","991":"15f05aca"}[chunkId] + ".chunk.js";
};